import { useMutation } from '@tanstack/react-query'

import { BooleanSuccessEnvelop, FailureEnvelop } from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'

export default function usePostWishlist() {
    return useMutation<BooleanSuccessEnvelop, FailureEnvelop['errors'], { productId: string }>({
        mutationFn: async ({ productId }) =>
            fetchRequest({ method: 'POST', serviceName: 'ntl', endpoint: '/wishlist', body: { productId } }),
    })
}
